"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFlagFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27 3l-1.28.36A22.73 22.73 0 0120 4a9 9 0 01-3.92-1A9.64 9.64 0 0012 2a10.46 10.46 0 00-5.6 1.48l-.4.3V30h2V17.89a9.19 9.19 0 014-.9 7.75 7.75 0 013.29.86A10.93 10.93 0 0020 19a18 18 0 006.38-1.06l.62-.26z" })));
}
exports.default = SvgFlagFilled;
//# sourceMappingURL=FlagFilled.js.map